<template>
    <div class="inside_pages_right">
        <ParentDefence></ParentDefence>
        <div class="inside_pages_right_content">
            <div class="content_top_three ">
                <div class="inside_pages_right_content_top_left ">
                    <el-button  type="primary" plain size="mini" icon="el-icon-circle-plus-outline">
                        新增科目
                    </el-button>
                </div>
            </div>
            <div class="content_center_three">
                <el-table :data="responseData.list"  height="100%" border style="width: 100%">
                    <el-table-column prop="id" label="编号" width="120">
                    </el-table-column>

                    <el-table-column prop="name1" label="科目名称">
                    </el-table-column>

                    <el-table-column prop="name2" label="科目图标">
                    </el-table-column>

                    <el-table-column prop="name3" label="发布人">
                    </el-table-column>

                    <el-table-column prop="date1" label="创建时间">
                        <template slot-scope="rowData">
                            {{$Common.dateFormatDate(rowData.row.date1)}}
                        </template>
                    </el-table-column>

                    <el-table-column  label="操作">
                        <template slot-scope="scope">
                            <el-button  type="primary" plain size="mini">
                                编辑
                            </el-button>
                            <el-button  type="primary" plain size="mini">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="content_bottom_three">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="responseData.pageNum"
                :page-sizes="[100, 200, 300, 400]"
                :page-size="20"
                layout="total, sizes, prev, pager, next, jumper"
                :total="responseData.total">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import ParentDefence from '@/components/ParentDefence'
export default {
    name:'',
    components: {ParentDefence},
    props: {},
    data() {
        return {
            requestData:{
                schoolId:this.$store.state.schoolId,
                pageSize:20,
                pageNum:1,
                name:'',
            },
            responseData:{
                pageSize:20,
                pageNum:1,
                total:100,
                pages:20,
                list:[
                    {
                        id:123,
                        name1: '科目名称测试',
                        name2: '科目图标测试',
                        name3: '发布人测试',
                        date1: 1593273599,
                    }, 
                    {
                        id:123,
                        name1: '科目名称测试',
                        name2: '科目图标测试',
                        name3: '发布人测试',
                        date1: 1593273599,
                    }, 
                ],
            },
        };
    },
    watch: {},
    computed: {},
    methods: {
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        }
        
    },
    created() {},
    mounted() {
    
    }
};
</script>